import {createApi} from '@reduxjs/toolkit/query/react';

import {promptBridgeBaseQuery} from '../baseQuery/promptBridgeBaseQuery';

export const promptBridgeApi = createApi({
  baseQuery: promptBridgeBaseQuery,
  reducerPath: 'rtk_promptBridgeApi',
  tagTypes: [
    'PromptBridgeMessage',
    'PromptBridgePrompt',
    'PromptBridgeUsage',
    'PromptBridgeHealthCheck',
    'PromptBridgeAdmin',
    'PromptBridgeOpenAI',
    'PromptBridgeStorageService',
  ],
  endpoints: () => ({}),
});
